(function (root) {
  'use strict';

  function normalize(value) {
    return String(value == null ? '' : value).trim().toLowerCase();
  }

  function priceSummary(braPrice, bottomPrice, cartPriced) {
    var items = Math.max(0, Number(braPrice) || 0) + Math.max(0, Number(bottomPrice) || 0);
    if (cartPriced) return { items: items, saving: null, total: null };
    var saving = Math.round(items * 0.1);
    return { items: items, saving: saving, total: items - saving };
  }

  function productColours(product) {
    if (!product) return [];
    if (Array.isArray(product.colours)) return product.colours.slice();
    var core = root.FormwynnSetEventCore;
    var colourIndex = core ? core.findOptionIndex(product.options, ['color', 'colour']) : -1;
    if (colourIndex < 0) return product.has_only_default_variant ? [''] : [];
    var seen = Object.create(null);
    return (product.variants || []).reduce(function (colours, variant) {
      var colour = String((variant.options || [])[colourIndex] || '').trim();
      var key = normalize(colour);
      if (colour && !seen[key]) {
        seen[key] = true;
        colours.push(colour);
      }
      return colours;
    }, []);
  }

  function validatePreselection(catalogue, requested) {
    if (!requested || !requested.bra || !requested.bottom) return null;
    var bra = catalogue && catalogue.bra && catalogue.bra[requested.bra];
    var bottom = catalogue && catalogue.bottom && catalogue.bottom[requested.bottom];
    if (!bra || !bottom) return null;
    var braColours = productColours(bra);
    var bottomColours = productColours(bottom);
    var requestedBraColour = normalize(requested.braColour);
    var requestedBottomColour = normalize(requested.bottomColour);
    var braColour = requestedBraColour
      ? braColours.find(function (value) { return normalize(value) === requestedBraColour; })
      : braColours[0] || '';
    var bottomColour = requestedBottomColour
      ? bottomColours.find(function (value) { return normalize(value) === requestedBottomColour; })
      : bottomColours[0] || '';
    if (requestedBraColour && !braColour) return null;
    if (requestedBottomColour && !bottomColour) return null;
    return {
      bra: bra.handle,
      bottom: bottom.handle,
      braColour: braColour,
      bottomColour: bottomColour,
      braVariantId: null,
      bottomVariantId: null,
    };
  }

  function createFeaturedDialogState(catalogue, requested) {
    var validated = validatePreselection(catalogue, requested);
    if (!validated) return null;
    return {
      products: {
        bra: catalogue.bra[validated.bra],
        bottom: catalogue.bottom[validated.bottom],
      },
      colours: {
        bra: validated.braColour,
        bottom: validated.bottomColour,
      },
      variants: { bra: null, bottom: null },
    };
  }

  function createCustomDialogState() {
    return {
      products: { bra: null, bottom: null },
      colours: { bra: '', bottom: '' },
      variants: { bra: null, bottom: null },
    };
  }

  var testHooks = root.__FORMWYNN_BUILD_SET_V2_TEST__;
  if (Array.isArray(testHooks)) testHooks.push({
    priceSummary: priceSummary,
    productColours: productColours,
    validatePreselection: validatePreselection,
    createFeaturedDialogState: createFeaturedDialogState,
    createCustomDialogState: createCustomDialogState,
  });

  if (!root.document) return;

  function one(selector, context) {
    return (context || root.document).querySelector(selector);
  }

  function all(selector, context) {
    return Array.prototype.slice.call((context || root.document).querySelectorAll(selector));
  }

  function marketRoot() {
    var value = root.Shopify && root.Shopify.routes && root.Shopify.routes.root;
    return value || '/';
  }

  function money(section, cents) {
    if (root.Shopify && typeof root.Shopify.formatMoney === 'function') {
      return root.Shopify.formatMoney(cents, section.dataset.moneyFormat);
    }
    try {
      return new Intl.NumberFormat(root.document.documentElement.lang || 'en-GB', {
        style: 'currency',
        currency: section.dataset.currency || 'GBP',
      }).format((Number(cents) || 0) / 100);
    } catch (_error) {
      return ((Number(cents) || 0) / 100).toFixed(2);
    }
  }

  function track(name, detail) {
    root.dataLayer = root.dataLayer || [];
    root.dataLayer.push(Object.assign({ event: name }, detail || {}));
  }

  function parseCatalogue(section) {
    var map = { bra: Object.create(null), bottom: Object.create(null) };
    all('[data-build-set-product-json]', section).forEach(function (node) {
      var role = node.dataset.productRole;
      try {
        var product = JSON.parse(node.textContent);
        if ((role === 'bra' || role === 'bottom') && product && product.handle) map[role][product.handle] = product;
      } catch (_error) {
        /* Invalid product data fails closed. */
      }
    });
    return map;
  }

  function variantForId(product, id) {
    return (product && product.variants || []).find(function (variant) { return Number(variant.id) === Number(id); }) || null;
  }

  function pricedVariant(product, colour, selectedId) {
    var chosen = variantForId(product, selectedId);
    if (chosen) return chosen;
    var core = root.FormwynnSetEventCore;
    var choices = core ? core.buildVariantChoices(product, colour) : [];
    var available = choices.find(function (choice) { return choice.available; });
    return variantForId(product, available && available.id) || null;
  }

  function setOptions(select, values, selected) {
    select.replaceChildren();
    values.forEach(function (value) {
      var option = root.document.createElement('option');
      option.value = value;
      option.textContent = value || 'Default';
      select.appendChild(option);
    });
    if (values.some(function (value) { return normalize(value) === normalize(selected); })) {
      select.value = values.find(function (value) { return normalize(value) === normalize(selected); });
    }
  }

  function featuredDialog(section) {
    return one('[data-build-set-featured-dialog]', section);
  }

  function featuredDialogStatus(section, message) {
    var dialog = featuredDialog(section);
    var node = dialog && one('[data-build-set-dialog-status]', dialog);
    if (node) node.textContent = message || '';
  }

  function featuredDialogFocusable(dialog) {
    return all('button:not([disabled]):not([tabindex="-1"]), [href]:not([tabindex="-1"]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])', dialog)
      .filter(function (element) { return !element.hidden && element.offsetParent !== null; });
  }

  function trapDialogFocus(event, dialog) {
    if (event.key !== 'Tab') return;
    var focusable = featuredDialogFocusable(dialog);
    if (!focusable.length) return;
    var first = focusable[0];
    var last = focusable[focusable.length - 1];
    if (focusable.indexOf(root.document.activeElement) === -1) {
      event.preventDefault();
      (event.shiftKey ? last : first).focus();
      return;
    }
    if (event.shiftKey && root.document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && root.document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  }

  function closeFeaturedDialog(section, restoreFocus) {
    var dialog = featuredDialog(section);
    var state = section._fwBuildSetState;
    if (!dialog || dialog.hidden) return;
    var add = one('[data-build-set-dialog-add]', dialog);
    if (add && add.dataset.loading === 'true') return;
    dialog.setAttribute('aria-hidden', 'true');
    dialog.dataset.buildSetDialogOpen = 'false';
    dialog.hidden = true;
    root.document.body.classList.remove('fw-build-set-dialog-open');
    if (section._fwBuildSetDialogKeydown) {
      root.document.removeEventListener('keydown', section._fwBuildSetDialogKeydown);
      section._fwBuildSetDialogKeydown = null;
    }
    var trigger = state.dialog && state.dialog.trigger;
    if (restoreFocus !== false && trigger && typeof trigger.focus === 'function') trigger.focus();
  }

  function dialogImage(product, colour) {
    var core = root.FormwynnSetEventCore;
    var imageUrl = '';
    var choices = core ? core.buildVariantChoices(product, colour) : [];
    for (var index = 0; index < choices.length; index += 1) {
      var variant = variantForId(product, choices[index].id);
      if (variant && variant.image) {
        imageUrl = variant.image;
        break;
      }
    }
    return imageUrl || product && product.featured_image || '';
  }

  function renderFeaturedDialogMedia(section, role) {
    var dialog = featuredDialog(section);
    var state = section._fwBuildSetState.dialog;
    var product = state.products[role];
    var colour = state.colours[role];
    var container = one('[data-build-set-dialog-media="' + role + '"]', dialog);
    var title = one('[data-build-set-dialog-title="' + role + '"]', dialog);
    container.replaceChildren();
    if (!product) {
      title.textContent = 'Choose a ' + role;
      title.removeAttribute('href');
      var empty = root.document.createElement('span');
      empty.textContent = 'Choose a style to preview it.';
      container.appendChild(empty);
      return;
    }
    var imageUrl = dialogImage(product, colour);
    title.textContent = product.title;
    title.href = product.url;
    if (!imageUrl) {
      var fallback = root.document.createElement('span');
      fallback.textContent = 'Image unavailable for ' + product.title + '.';
      container.appendChild(fallback);
      return;
    }
    var image = root.document.createElement('img');
    image.src = imageUrl;
    image.alt = product.title + (colour ? ' in ' + colour : '');
    image.width = 720;
    image.height = 900;
    image.loading = 'lazy';
    container.appendChild(image);
  }

  function renderFeaturedDialogSizes(section, role) {
    var dialog = featuredDialog(section);
    var state = section._fwBuildSetState.dialog;
    var container = one('[data-build-set-dialog-sizes="' + role + '"]', dialog);
    var core = root.FormwynnSetEventCore;
    container.replaceChildren();
    state.variants[role] = null;
    if (!core || !state.products[role]) {
      var prompt = root.document.createElement('span');
      prompt.className = 'fw-build-set__dialog-size-prompt';
      prompt.textContent = 'Choose a style first';
      container.appendChild(prompt);
      return;
    }
    core.buildVariantChoices(state.products[role], state.colours[role]).forEach(function (choice) {
      var button = root.document.createElement('button');
      button.type = 'button';
      button.textContent = choice.size;
      button.dataset.buildSetDialogSize = role;
      button.dataset.variantId = String(choice.id);
      button.setAttribute('aria-pressed', 'false');
      if (!choice.available) {
        button.disabled = true;
        button.setAttribute('aria-label', choice.size + ' — sold out');
      } else {
        button.setAttribute('aria-label', 'Select ' + role + ' size ' + choice.size);
      }
      if (choice.autoSelected && choice.available) {
        button.setAttribute('aria-pressed', 'true');
        state.variants[role] = Number(choice.id);
      }
      container.appendChild(button);
    });
  }

  function updateFeaturedDialogSummary(section) {
    var dialog = featuredDialog(section);
    var state = section._fwBuildSetState.dialog;
    if (!dialog || !state) return;
    var braVariant = pricedVariant(state.products.bra, state.colours.bra, state.variants.bra);
    var bottomVariant = pricedVariant(state.products.bottom, state.colours.bottom, state.variants.bottom);
    var cartPriced = state.products.bottom && state.products.bottom.handle === 'tummy-control-stirrup-leggings';
    var summary = priceSummary(braVariant && braVariant.price, bottomVariant && bottomVariant.price, cartPriced);
    one('[data-set-items-total]', dialog).textContent = money(section, summary.items);
    one('[data-set-saving]', dialog).textContent = cartPriced ? 'Current offer applies' : '−' + money(section, summary.saving);
    one('[data-set-total]', dialog).textContent = cartPriced ? 'Confirmed in bag' : money(section, summary.total);
    one('[data-set-saving]', dialog).previousElementSibling.textContent = cartPriced ? 'PROMOTIONAL PRICING' : 'AUTOMATIC SET SAVING';
    one('[data-build-set-dialog-unit-price="bra"]', dialog).textContent = braVariant ? money(section, braVariant.price) : '—';
    one('[data-build-set-dialog-unit-price="bottom"]', dialog).textContent = bottomVariant ? money(section, bottomVariant.price) : '—';
    var add = one('[data-build-set-dialog-add]', dialog);
    add.disabled = !(state.variants.bra && state.variants.bottom) || add.dataset.loading === 'true';
    add.textContent = summary.total ? 'ADD BOTH TO BAG — ' + money(section, summary.total) : 'ADD BOTH TO BAG';
    state.expected = summary;
    if (state.products.bra && state.products.bottom) {
      var signature = [state.products.bra.handle, braVariant && braVariant.id, state.products.bottom.handle, bottomVariant && bottomVariant.id, summary.total, section.dataset.currency].join(':');
      if (state.priceSignature !== signature) {
        state.priceSignature = signature;
        track('builder_price_view', { items_total: summary.items, expected_saving: summary.saving, expected_total: summary.total, currency: section.dataset.currency });
      }
    }
  }

  function syncFeaturedDialogColour(section, role) {
    var dialog = featuredDialog(section);
    var state = section._fwBuildSetState.dialog;
    var select = one('[data-build-set-dialog-colour="' + role + '"]', dialog);
    state.colours[role] = select.value;
    renderFeaturedDialogMedia(section, role);
    renderFeaturedDialogSizes(section, role);
    updateFeaturedDialogSummary(section);
    featuredDialogStatus(section, 'Choose both sizes to add the set.');
  }

  function renderDialogRole(section, role, requestedColour) {
    var dialog = featuredDialog(section);
    var state = section._fwBuildSetState.dialog;
    var product = state.products[role];
    var colourSelect = one('[data-build-set-dialog-colour="' + role + '"]', dialog);
    if (!product) {
      state.colours[role] = '';
      state.variants[role] = null;
      setOptions(colourSelect, [''], '');
      colourSelect.options[0].textContent = 'Choose a style first';
      colourSelect.disabled = true;
    } else {
      setOptions(colourSelect, productColours(product), requestedColour || state.colours[role]);
      colourSelect.disabled = false;
      state.colours[role] = colourSelect.value;
    }
    renderFeaturedDialogMedia(section, role);
    renderFeaturedDialogSizes(section, role);
  }

  function syncDialogStyle(section, role) {
    var dialog = featuredDialog(section);
    var state = section._fwBuildSetState.dialog;
    var style = one('[data-build-set-dialog-style="' + role + '"]', dialog);
    state.products[role] = section._fwBuildSetState.catalogue[role][style.value] || null;
    state.colours[role] = '';
    state.variants[role] = null;
    renderDialogRole(section, role, '');
    updateFeaturedDialogSummary(section);
    featuredDialogStatus(section, state.products.bra && state.products.bottom
      ? 'Choose both sizes to add the set.'
      : 'Choose a bra and a bottom to continue.');
    track('builder_product_select', { role: role, product_handle: style.value, source: 'selection_dialog' });
  }

  function openDialogLifecycle(section, trigger) {
    var dialog = featuredDialog(section);
    section._fwBuildSetState.dialog.trigger = trigger;
    dialog.hidden = false;
    dialog.setAttribute('aria-hidden', 'false');
    dialog.dataset.buildSetDialogOpen = 'true';
    root.document.body.classList.add('fw-build-set-dialog-open');
    section._fwBuildSetDialogKeydown = function (event) {
      if (event.key === 'Escape') {
        event.preventDefault();
        closeFeaturedDialog(section, true);
        return;
      }
      trapDialogFocus(event, dialog);
    };
    root.document.addEventListener('keydown', section._fwBuildSetDialogKeydown);
    root.setTimeout(function () {
      var firstStyle = one('[data-build-set-dialog-style="bra"]', dialog);
      if (firstStyle) firstStyle.focus();
    }, 0);
    return true;
  }

  function openFeaturedDialog(section, trigger) {
    var state = section._fwBuildSetState;
    var dialog = featuredDialog(section);
    var next = createFeaturedDialogState(state.catalogue, {
      bra: trigger.dataset.braHandle,
      bottom: trigger.dataset.bottomHandle,
      braColour: trigger.dataset.braColour,
      bottomColour: trigger.dataset.bottomColour,
    });
    if (!dialog || !next) return false;
    next.expected = priceSummary(0, 0);
    next.priceSignature = '';
    next.mode = 'featured';
    state.dialog = next;
    ['bra', 'bottom'].forEach(function (role) {
      var style = one('[data-build-set-dialog-style="' + role + '"]', dialog);
      style.value = next.products[role].handle;
      renderDialogRole(section, role, next.colours[role]);
    });
    updateFeaturedDialogSummary(section);
    featuredDialogStatus(section, 'Choose both sizes to add the set.');
    return openDialogLifecycle(section, trigger);
  }

  function openCustomDialog(section, trigger) {
    var dialog = featuredDialog(section);
    if (!dialog) return false;
    var next = createCustomDialogState();
    next.expected = priceSummary(0, 0);
    next.priceSignature = '';
    next.mode = 'custom';
    section._fwBuildSetState.dialog = next;
    ['bra', 'bottom'].forEach(function (role) {
      one('[data-build-set-dialog-style="' + role + '"]', dialog).value = '';
      renderDialogRole(section, role, '');
    });
    updateFeaturedDialogSummary(section);
    featuredDialogStatus(section, 'Choose a bra and a bottom to continue.');
    return openDialogLifecycle(section, trigger);
  }

  function cartHasVerifiedDiscount(cart, slug) {
    var hasRequestedSet = (cart.items || []).some(function (item) {
      var properties = item.properties || {};
      if (properties._formwynn_set !== slug) return false;
      return (item.discount_allocations || []).some(function (allocation) {
        return Number(allocation.amount) > 0;
      });
    });
    if (hasRequestedSet) return true;

    var hasBothSetLines = ['bra', 'bottom'].every(function (role) {
      return (cart.items || []).some(function (item) {
        var properties = item.properties || {};
        return properties._formwynn_set === slug && properties._formwynn_set_role === role;
      });
    });
    if (!hasBothSetLines) return false;

    return (cart.cart_level_discount_applications || []).some(function (application) {
      return Number(application.total_allocated_amount) > 0;
    });
  }

  async function verifyCartDiscount(slug) {
    var cartUrl = root.routes && root.routes.cart_url ? root.routes.cart_url : marketRoot() + 'cart';
    var response = await root.fetch(cartUrl + '.js', { headers: { Accept: 'application/json' } });
    if (!response.ok) return false;
    return cartHasVerifiedDiscount(await response.json(), slug);
  }

  function refreshCart(result, trigger) {
    var drawer = root.document.querySelector('cart-drawer');
    if (!drawer || !result.sections || typeof drawer.renderContents !== 'function') return false;
    if (typeof drawer.setActiveElement === 'function') drawer.setActiveElement(trigger);
    drawer.renderContents(result);
    return true;
  }

  async function addFeaturedSet(section) {
    var pageState = section._fwBuildSetState;
    var state = pageState.dialog;
    var dialog = featuredDialog(section);
    var button = dialog && one('[data-build-set-dialog-add]', dialog);
    if (!state || !button || button.dataset.loading === 'true' || !state.variants.bra || !state.variants.bottom) return;
    var slug = 'build-your-set-v2-' + Date.now();
    var core = root.FormwynnSetEventCore;
    button.dataset.loading = 'true';
    button.disabled = true;
    button.textContent = 'ADDING…';
    featuredDialogStatus(section, 'Adding both pieces to your bag…');
    track('set_add_to_cart', {
      source: 'selection_dialog',
      bra_variant_id: state.variants.bra,
      bottom_variant_id: state.variants.bottom,
      expected_total: state.expected.total,
      currency: section.dataset.currency,
    });
    try {
      var payload = core.createAddPayload({ slug: slug }, state.variants.bra, state.variants.bottom, root.location.pathname);
      var addUrl = root.routes && root.routes.cart_add_url ? root.routes.cart_add_url : marketRoot() + 'cart/add.js';
      var response = await root.fetch(addUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(payload),
      });
      var result = await response.json();
      if (!response.ok) throw new Error(result.description || result.message || 'Unable to add the set.');
      refreshCart(result, state.trigger || button);
      var verified = false;
      try { verified = await verifyCartDiscount(slug); } catch (_error) { verified = false; }
      track(verified ? 'set_discount_verified' : 'set_discount_pending', {
        source: 'selection_dialog',
        bra_variant_id: state.variants.bra,
        bottom_variant_id: state.variants.bottom,
        expected_saving: state.expected.saving,
        currency: section.dataset.currency,
      });
      if (section.dataset.setEventStatus === 'active' || section.dataset.setEventStatus === 'final') {
        track('towel_qualified', { qualification_source: 'build_your_set_v2' });
      }
      featuredDialogStatus(section, verified
        ? 'Set added. The automatic saving is confirmed in your bag.'
        : 'Set added. Your bag is the final record of the automatic saving.');
      button.dataset.loading = 'false';
      closeFeaturedDialog(section, false);
    } catch (error) {
      featuredDialogStatus(section, error && error.message ? error.message : 'Something went wrong. Please try again.');
    } finally {
      button.dataset.loading = 'false';
      if (!dialog.hidden) updateFeaturedDialogSummary(section);
    }
  }

  function init(section) {
    if (section.dataset.buildSetBound === 'true') return;
    section.dataset.buildSetBound = 'true';
    var catalogue = parseCatalogue(section);
    section._fwBuildSetState = {
      catalogue: catalogue,
      dialog: null,
    };
    section.addEventListener('click', function (event) {
      var closeDialog = event.target.closest('[data-build-set-dialog-close]');
      if (closeDialog) {
        closeFeaturedDialog(section, true);
        return;
      }
      var featured = event.target.closest('[data-build-set-featured-select]');
      if (featured) {
        var applied = openFeaturedDialog(section, featured);
        if (applied) {
          track('featured_set_select', { bra: featured.dataset.braHandle, bottom: featured.dataset.bottomHandle });
        } else {
          openCustomDialog(section, featured);
          featuredDialogStatus(section, 'This suggested combination is currently unavailable. Choose another product or colour.');
        }
        return;
      }
      var custom = event.target.closest('[data-build-set-custom-select]');
      if (custom) {
        openCustomDialog(section, custom);
        track('builder_product_select', { source: 'selection_dialog', action: 'open_custom' });
        return;
      }
      var dialogSize = event.target.closest('[data-build-set-dialog-size]');
      if (dialogSize && !dialogSize.disabled) {
        var dialogRole = dialogSize.dataset.buildSetDialogSize;
        var dialog = featuredDialog(section);
        all('[data-build-set-dialog-size="' + dialogRole + '"]', dialog).forEach(function (button) {
          button.setAttribute('aria-pressed', button === dialogSize ? 'true' : 'false');
        });
        section._fwBuildSetState.dialog.variants[dialogRole] = Number(dialogSize.dataset.variantId);
        updateFeaturedDialogSummary(section);
        featuredDialogStatus(section, section._fwBuildSetState.dialog.variants.bra && section._fwBuildSetState.dialog.variants.bottom
          ? 'Both sizes selected. Your set is ready to add.'
          : 'Choose both sizes to add the set.');
        return;
      }
      var dialogAdd = event.target.closest('[data-build-set-dialog-add]');
      if (dialogAdd) {
        addFeaturedSet(section);
        return;
      }
    });
    all('[data-build-set-dialog-style]', section).forEach(function (select) {
      select.addEventListener('change', function () {
        if (section._fwBuildSetState.dialog) syncDialogStyle(section, select.dataset.buildSetDialogStyle);
      });
    });
    all('[data-build-set-dialog-colour]', section).forEach(function (select) {
      select.addEventListener('change', function () {
        if (!section._fwBuildSetState.dialog) return;
        syncFeaturedDialogColour(section, select.dataset.buildSetDialogColour);
      });
    });
    all('[data-build-set-assurance] a', section).forEach(function (link) {
      link.addEventListener('click', function () { track('purchase_assurance_click', { href: link.getAttribute('href') || '' }); });
    });
    section.dataset.buildSetEnhanced = 'true';
    track('build_set_page_view', { currency: section.dataset.currency, market: root.Shopify && root.Shopify.country || '' });
  }

  function initAll() {
    all('[data-build-set-v2]').forEach(init);
  }

  if (root.document.readyState === 'loading') root.document.addEventListener('DOMContentLoaded', initAll);
  else initAll();
})(typeof window !== 'undefined' ? window : globalThis);
